import GroupsManagement from "@/views/groups/GroupIndex.vue";
import AddGroup from "@/views/groups/AddGroup.vue";
import EditGroup from "@/views/groups/EditGroup.vue";

export default [
  {
    path: '/groups',
    name: 'groups.index',
    component: GroupsManagement,
    meta: { 
      title: 'groups.indexTitle', 
      requiresAuth: true,
      requiredPerm: 'groups.display',
    },
    children: [
      {
        path: 'add',
        name: 'groups.create',
        component: AddGroup,
        meta: { 
          title: 'groups.addTitle', 
          requiresAuth: true,
          requiredPerm: 'groups.create',
        }
      },
      {
        path: 'edit/:id',
        name: 'groups.edit',
        component: EditGroup,
        meta: { 
          title: 'groups.editTitle', 
          requiresAuth: true,
          requiredPerm: 'groups.update',
        },
        props: true
      }
    ]
  }
];
